import { dataFetcher } from "../dataFetcher";

// Services to add or remove a content item from a an xdbFacet list
// Example lists include: Bookmarks, Favorites
export const FAVORITES_ENDPOINT_ID = "Favorites";
export const READING_ENDPOINT_ID = "Reading";
export const TOOLS_ENDPOINT_ID = "Tools";
export const ONE_TIME_POPUP_ENDPOINT_ID = "Acknowledgments";

const xdbListServiceUrl = "/clientApi/SavedItems/";
export const AddItemToList = (itemId, listId) => {
  return dataFetcher(`${xdbListServiceUrl}AddToList`, {
    data: {
      ItemId: itemId,
      ListName: listId,
    }
  });
};

export const RemoveItemFromList = (itemId, listId) => {
  return dataFetcher(`${xdbListServiceUrl}RemoveFromList`, {
    data: {
      ItemId: itemId,
      ListName: listId,
    },
  });
};

export const GetList = (listId) => {
  return dataFetcher(
    `${xdbListServiceUrl}GetList?listName=${listId}`,
    null
  );
};

export const GetListingItems = (listId) => {
  return dataFetcher(
    `${xdbListServiceUrl}GetListing?listName=${listId}`,
    null
  );
};


export const SaveOrderedList = (myjson,  listId) => {
  return dataFetcher(`${xdbListServiceUrl}UpdateList?listName=${listId}`,
  {
    data : {
      JsonData: myjson
    }
  }
);
};

export const GetSavedItemsAPICompatibleGUID = (id) => {
  const multilistSerializedId = /^[[0-9A-F]{8}(?:[0-9A-F]{4}){3}[0-9A-F]{12}$/;
  const match = id?.match(multilistSerializedId);
  var newGuid = id;

  if (match?.length > 0) {
    id = id.toLowerCase();

    var parts = [];
    parts.push(id.slice(0, 8));
    parts.push(id.slice(8, 12));
    parts.push(id.slice(12, 16));
    parts.push(id.slice(16, 20));
    parts.push(id.slice(20, 32));
    newGuid = parts.join('-');
  }
  return newGuid;
}

export const AddToNewsSubscriptions = (ids: string[]) => {
  return dataFetcher(`${xdbListServiceUrl}news-subscriptions`, {
    data: { 
      ItemIds: ids 
    }});
};

export const RemoveFromNewsSubscriptions = (ids: string[]) => {
  return dataFetcher(`${xdbListServiceUrl}news-subscriptions-remove`, {
    data: { 
      ItemIds: ids 
    }});
};